import React from 'react'
import styled, { css } from 'styled-components'

const TitleWrap = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 40%;
    text-align: center;

    ${(props) =>
        props.rightAlign &&
        css({
            'text-align': 'right',
        })}
    ${(props) =>
        props.leftAlign &&
        css({
            'text-align': 'left',
        })}
${(props) =>
        props.UniWidth &&
        css({
            width: props.UniWidth,
        })}

h4 {
        font-size: 20px;
        font-weight: 500;
        color: ${(props) => (props.theme.textColor ? props.theme.textColor : '#ffffff')};
        margin: 0 0 16px 0;
    }
    h2 {
        font-size: 40px;
        font-weight: 300;
        line-height: 50px;
        color: ${(props) => props.theme.whiteToBlack};
        margin: 0 0 75px 0;
        span {
            font-weight: 600;
            color: #3c494f;
        }
        transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    }
    @media only screen and (max-width: 912px) {
        width: 100%;
        h2 {
            font-size: 24px;
            line-height: 35px;
        }
        .section-title h2 {
            margin-bottom: 20px;
        }
    }
`
export const SectionTitle = ({ children, ...props }) => {
    return <TitleWrap {...props}>{children}</TitleWrap>
}

export default SectionTitle
